/**
 * Use to indicate that an error should be displayed to the user.
 */
export class PaymentDisplayError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PaymentDisplayError';
  }
}
